module.exports = __webpack_public_path__ + "img/2ae21cfe0ded45c6fecdf6eb8617cca6.png";